import { useEffect } from "react";

const SEO = ()=> {
    return (
        <></>
    )
}

export default SEO;